export default [
  {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum blandit nisl tortor, ac sodales justo pellentesque sed.',
    author: 'Lorem ipsum dolor',
    author_title: 'Lorem ipsum dolor sit amet',
    author_logo: 'https://backlight.dev/assets/lib-white/sass.svg',
    author_log_alt: 'test',
  },
  {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum blandit nisl tortor, ac sodales justo pellentesque sed. Integer efficitur viverra lacus, eget condimentum mauris dictum ut.',
    author: 'Lorem ipsum dolor',
    author_title: 'Lorem ipsum dolor sit amet',
    author_logo: 'https://backlight.dev/assets/lib-white/sass.svg',
    author_log_alt: 'test',
  },
  {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum blandit nisl tortor, ac sodales justo pellentesque sed. Integer efficitur viverra lacus, eget condimentum mauris dictum ut. Nulla a semper eros. Curabitur eget condimentum urna. Aliquam sit amet lectus vehicula, mattis nibh quis, vestibulum odio.',
    author: 'Lorem ipsum dolor',
    author_title: 'Lorem ipsum dolor sit amet',
    author_logo: 'https://backlight.dev/assets/lib-white/sass.svg',
    author_log_alt: 'test',
  },
  {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum blandit nisl tortor, ac sodales justo pellentesque sed. Integer efficitur viverra lacus, eget condimentum mauris dictum ut.',
    author: 'Lorem ipsum dolor',
    author_title: 'Lorem ipsum dolor sit amet',
    author_logo: 'https://backlight.dev/assets/lib-white/sass.svg',
    author_log_alt: 'test',
  },
];
